import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loading } from '../ui/Loading';

/**
 * PublicRoute component - Used for public routes like login and register
 * Prevents automatic redirections when accessing the register page
 */
export function PublicRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show loading indicator while checking authentication
  if (loading) {
    return <Loading />;
  }

  // For the register page, always render it regardless of auth status
  if (location.pathname === '/auth/register') {
    return <Outlet />;
  }

  // For other auth pages, redirect to dashboard if already authenticated
  if (user && !location.pathname.includes('/auth/register')) {
    return <Navigate to="/dashboard" replace />;
  }

  // Render the public content
  return <Outlet />;
} 
